import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import "../Assets/css/index.css";

const NotificationsSettings = ({ locationState }) => {
  const [showNotification, setShowNotification] = useState(true);
  const [showNotificationOnly, setShowNotificationOnly] = useState(false);
  const [settings, setSettings] = useState({
    sendEmail: false,
    generalUpdates: true,
    pushNotifications: false,
    inAppNotifications: true,
    collaborationMilestones: true,
  });

  const notificationOptions = [
    {
      key: "sendEmail",
      title: "Send Me Email Notifications",
      description:
        "Receive important updates about your account, collaborations, and announcements directly in your inbox.",
    },
    {
      key: "generalUpdates",
      title: "General Updates",
      description:
        "Get notified about your account activity, including collaboration status, new messages, and profile insights.",
    },
    {
      key: "pushNotifications",
      title: "Push Notifications",
      description:
        "Allow Insocial Orbit to send real-time updates to your mobile device, so you never miss an opportunity.",
    },
    {
      key: "inAppNotifications",
      title: "In App Notifications",
      description:
        "Get alerts within the platform for collaboration requests, messages, and important account activity.",
    },
    {
      key: "collaborationMilestones",
      title: "Collaboration Milestones",
      description:
        "Receive notifications for key steps like content submissions, deadlines, or approvals.",
    },
  ];

  useEffect(() => {
    const savedNotificationSetting = JSON.parse(
      localStorage.getItem("showNotification")
    );
    if (savedNotificationSetting !== null) {
      setShowNotification(savedNotificationSetting);
    }
  }, []);

  useEffect(() => {
    if (
      locationState?.showNotification ||
      sessionStorage.getItem("showNotification") === "true"
    ) {
      setShowNotification(true);
      sessionStorage.removeItem("showNotification");
    }
  }, [locationState]);

  useEffect(() => {
    if (locationState?.section === "account-preferences") {
      setShowNotificationOnly(false);
    } else if (
      locationState?.showNotificationOnly ||
      locationState?.section === "notifications"
    ) {
      setShowNotificationOnly(true);
    }
  }, [locationState]);

  const handleToggleNotification = () => {
    const newValue = !showNotification;
    setShowNotification(newValue);
    localStorage.setItem("showNotification", JSON.stringify(newValue));
    window.dispatchEvent(new Event("storage"));
  };

  const handleToggle = (key) => {
    setSettings((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <div className="settings-container mt-2 vh-100">
      {notificationOptions.map((item) => (
        <div
          key={item.key}
          className="d-flex justify-content-between align-items-center notification-toggle border-bottom py-3"
        >
          <div>
            <span className="notification-label fw-semibold d-block">
              {item.title}
            </span>
            <small className="text-muted">{item.description}</small>
          </div>
          {item.key === "generalUpdates" ? (
            <div className="d-flex justify-content-between align-items-center">
              <span className="notification-label me-3"></span>
              <Form.Check
                type="switch"
                id="notification-switch"
                checked={showNotification}
                onChange={handleToggleNotification}
              />
            </div>
          ) : (
            <Form.Check
              type="switch"
              id={`switch-${item.key}`}
              checked={settings[item.key]}
              onChange={() => handleToggle(item.key)}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default NotificationsSettings;
